import RestApiModel from "@/api/Model/RestApiModel";

class SalesDocument extends RestApiModel {
  static getResourceEndpoint() {
    return '/GetSalesDocument';
  }
}

export default SalesDocument;
